import React from "react";
import {ChatBotIcon} from "@hugeicons/core-free-icons";
import {MiniCard} from "./MiniCard";
import {PeriodMenu} from "./PeriodMenu";
import {ResponseTimeNavigation} from "./ResponseTimeNavigation";
import {useDashboard} from "../../../../context/DashboardContext";
import {formatSeconds, hasActivity, toChartData} from "./response-time-utils";

export const ChatbotCard = () => {
  const {responseTime} = useDashboard();
  const statistic = responseTime?.CHATBOT;
  const chartData = toChartData(statistic);

  return (
    <MiniCard
      icon={ChatBotIcon}
      color={"#1979a3"}
      title={formatSeconds(statistic)}
      subtitle={"CHATBOT"}
      data={chartData}
      hideChart={!hasActivity(chartData)}
      action={<PeriodMenu type={"CHATBOT"}/>}
      chartOverlay={<ResponseTimeNavigation type={"CHATBOT"}/>}
    />
  );
};
